import React, { useState, useEffect } from 'react';
import { certifications as allCerts } from '../data';
import './Certifications.css';

const Certifications = () => {
  const [certifications, setCertifications] = useState([]);

  useEffect(() => {
    setCertifications(allCerts);
  }, []);

  return (
    <section id="certifications" className="sec">
      <div className="sec-inner">
        <div className="sec-label">06 — Certifications</div>
        <h2 className="sec-title">Credentials that<br /><em>mean something</em></h2>

        <div className="certs-list reveal">
          {certifications.map((cert, index) => (
            <div className="cert-item" key={cert._id || index}>
              <div className="cert-org">{cert.issuer}</div>
              <div className="cert-title">{cert.title}</div>
              <div className="cert-yr">{cert.date}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
